import { create } from "zustand";

export type NotificationSeverity = "success" | "error" | "info" | "warning";

export interface AppNotification {
  id: number;
  message: string;
  severity: NotificationSeverity;
  autoHideDuration?: number;
}

interface NotificationState {
  queue: AppNotification[];
  counter: number;
  enqueue: (notification: Omit<AppNotification, "id">) => void;
  dequeue: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  queue: [],
  counter: 1,
  enqueue: (notification) =>
    set((state) => ({
      queue: [...state.queue, { ...notification, id: state.counter }],
      counter: state.counter + 1
    })),
  dequeue: () =>
    set((state) => ({
      queue: state.queue.slice(1)
    }))
}));
